import { Box, BoxProps, Center, useColorModeValue } from "@chakra-ui/react";
import React from "react";

import ReflagLogo from "@/common/assets/reflag-logo.svg?react";

export default function CenteredLayout({
  children,
  showReflagLogo = false,
  ...props
}: {
  children: React.ReactNode;
  showReflagLogo?: boolean;
} & BoxProps) {
  const logoColor = useColorModeValue("gray.900", "white");

  return (
    <>
      {showReflagLogo && (
        <Box color={logoColor} left={6} pos="absolute" top={6}>
          <ReflagLogo width="20" />
        </Box>
      )}
      <Center
        bg={useColorModeValue("white", "gray.900")}
        minH="100vh"
        px={6}
        py={16}
        width="100%"
        {...props}
      >
        {children}
      </Center>
    </>
  );
}
